module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_personaljournalapp.815906be.jpg";